import { I18n } from '@calendly/i18n';
import { Loader as CuiLoader } from '@calendly/ui/components/loader';
import { BareItem as Item } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useBooleanState } from 'hooks/useBooleanState';
import { useIsMounted } from 'hooks/useIsMounted';
const textCss = "t1k2y1yk";
const Text = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(textCss, props.className)} />;
});
const loaderCss = "lsv0m0x";
const Loader = forwardRef((props, ref) => <CuiLoader ref={ref} {...props} className={classNames(loaderCss, props.className)} />);
const ShowMore = ({
  onClick
}) => {
  const [isLoading, startLoading, stopLoading] = useBooleanState(false);
  const isMounted = useIsMounted();
  const wrappedOnClick = async () => {
    startLoading();
    await onClick();
    if (isMounted.current) stopLoading();
  };
  if (isLoading) return <Loader size="small" />;
  return <Item onClick={wrappedOnClick}>
      <Text>
        {I18n.t('publisher.title.show_more')}
      </Text>
    </Item>;
};
export default ShowMore;

require("./show_more.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./show_more.js");